module.exports = __webpack_public_path__ + "static/media/expo-4-3-caption.7b495e0b.svg";